/* @flow */
import createHistory from 'history/createBrowserHistory';
import qs from 'qs';
import {setContentLang} from '../utilities/lang';
import ListenerManager from '../utilities/ListenerManager';
import {select, selectAll} from '../utilities/select';
import type {Module} from '../types';

const listeners: ListenerManager = new ListenerManager;
const defaultLang: ?string = window.weslife.defaultLang;

let history: {
  location: Location,
  replace: (path: string, state: ?Object) => void
};
let changeCallback: Function;

const getNextLangUrl: Function = (lang: string): string => {
  const {pathname, search, hash} = history.location;
  let query: { [key: string]: string } = qs.parse(search.replace(/^\?/, ''));
  query.lang = lang;
  if (lang === defaultLang) {
    delete query.lang;
  }
  return pathname + '?' + qs.stringify(query) + hash;
};

const changeLang: Function = (container: Element): EventHandler =>
  (e: Event): void => {
    e.preventDefault();
    const target: EventTarget | Element = e.target;
    if (!(target instanceof Element)) {
      return;
    }

    const lang: ?string = container.getAttribute('data-lang');
    const nextLang: ?string = target.getAttribute('data-lang');
    if (nextLang && lang !== nextLang) {
      container.setAttribute('data-lang', nextLang);
      history.replace(getNextLangUrl(nextLang));
      setContentLang(nextLang);
      changeCallback();
    }
  };

const langPicker: Module & {
  onChange: (callback: Function) => void
} = {
  init(): void {
    this.destroy();

    history = createHistory();
    changeCallback = function(): void {
      // noop
    };

    selectAll('.js-lang-picker').forEach((el: HTMLElement) => {
      const controls: ?HTMLElement = select('.js-lang-picker__controls', el);
      if (controls) {
        listeners.add(controls, 'click', changeLang(el));
      }
    });
  },
  onChange(callback: Function): void {
    changeCallback = callback;
  },
  destroy(): void {
    listeners.removeAll();
  }
};

export default langPicker;



// WEBPACK FOOTER //
// ./resources/assets/magazine/js/magazine/langPicker.js